import { Controller } from "@hotwired/stimulus"

// Toggles between supply-based and manually entered stock on the product form.
export default class extends Controller {
  static targets = ["select", "supplyFields", "manualFields", "manualInput", "priceGrid"]

  connect() {
    this.toggle()
  }

  toggle() {
    const mode = this.selectTarget.value
    const isSupplyBased = mode === "supply_based"

    this.supplyFieldsTargets.forEach(el => {
      el.classList.toggle("hidden", !isSupplyBased)
    })
    this.manualFieldsTargets.forEach(el => {
      el.classList.toggle("hidden", isSupplyBased)
    })
    this.manualInputTargets.forEach(input => {
      input.disabled = isSupplyBased
    })

    // Adjust grid columns: 3 for supply-based, 2 for manual.
    this.priceGridTargets.forEach(el => {
      el.classList.toggle("grid-cols-3", isSupplyBased)
      el.classList.toggle("grid-cols-2", !isSupplyBased)
    })
  }
}
